import type { ComponentProps } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { getStatusInitials } from '@/utils/get-status-initials'

const badgeVariants = tv({
  base: 'size-6 content-center text-white rounded-full text-center text-xs font-bold',
  variants: {
    variant: {
      B: 'bg-alert-danger',
      D: 'bg-alert-danger',
      P: 'bg-alert-warning',
      A: 'bg-alert-success',
    },
  },
  defaultVariants: {
    variant: 'A',
  },
})

export interface UserStatusBadgeProps
  extends VariantProps<typeof badgeVariants>,
    ComponentProps<'div'> {
  description: string
}

export function UserStatusBadge({
  variant,
  description,
  className,
  ...props
}: UserStatusBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={badgeVariants({
              variant,

              className,
            })}
            {...props}
          >
            <span>{getStatusInitials(description)}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
